import { render } from "./EntitlementSituationalModal.vue?vue&type=template&id=68838f5c&scoped=true"
import script from "./EntitlementSituationalModal.vue?vue&type=script&lang=js"
export * from "./EntitlementSituationalModal.vue?vue&type=script&lang=js"

import "./EntitlementSituationalModal.vue?vue&type=style&index=0&id=68838f5c&lang=scss&scoped=true"

import exportComponent from "/opt/karibu-hrms/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-68838f5c"]])

export default __exports__